import _ from 'lodash';

/**
 * Where a Filters-panel row lives in the presenter's list of rows (FE-107).
 *
 * By identity first: the panel and the active-filter chips hand back the presenter's own row objects, so this is
 * exact. A copy falls back to an EXACT match — never a partial one. `_.findIndex(rows, row)` matches the first row
 * that merely CONTAINS the given row's fields, so with two blank rows (the presenter's default one and one just
 * added) editing the second changed the first, and deleting a blank row could delete a filled one above it.
 *
 * `plain` turns a row into comparable data first — MobX rows need `toJS`, or two equal rows still differ.
 */
export function filterRowIndex<T>(rows: readonly T[], row: T, plain: (value: T) => unknown = (value): unknown => value): number {
    const byIdentity = rows.indexOf(row);
    if (byIdentity !== -1) {
        return byIdentity;
    }

    const wanted = plain(row);
    return rows.findIndex(candidate => _.isEqual(plain(candidate), wanted));
}
